import {
  FPlusFormattingProvider,
  FPlusHoverProvider,
  FPlusLanguageConfiguration,
  FPlusSignatureHelpProvider,
  FPlusSuggestionProvider,
  FPlusValidationProvider,
  type LanguageWorker,
  type LanguageWorkerAccessor,
  setupFPlusHighlighting,
  WorkerManager,
  type WorkerMapping,
} from '@festina-life/fplus-monaco'
import { languages, type Uri } from 'monaco-editor'
import editorWorker from 'monaco-editor/editor/editor.worker?worker'

import { fplusHighlighterProps } from '../highlighting/fplusHighlighterProps'
import type { ITextModel } from '../monaco/types/monaco'
import { asWorkerInput } from './AsWorkerInput'
// oxlint-disable-next-line import/default
import fPlusWorker from './FPlus.worker?worker'
import { languageExtensionPoint, languageID } from './FPlusConfiguration'

//Maybe rewrite to functional pattern with hooks at some point, is possible with all events being disposable
export async function setupFPlusLanguage() {
  window.MonacoEnvironment = {
    getWorker(_test: unknown, label?: string) {
      if (label === languageID) {
        return new fPlusWorker()
      }

      return new editorWorker()
    },
  }

  setupLanguage(asWorkerInput)

  // Must happen after the languages are registered and before any editor is
  // created, because Shiki patches monaco.editor.create.
  await setupFPlusHighlighting(fplusHighlighterProps)
}

function setupLanguage<T extends LanguageWorker<I>, I>(
  asWorkerInput: WorkerMapping<I>,
) {
  languages.register(languageExtensionPoint)
  languages.onLanguage(languageID, () => {
    languages.setLanguageConfiguration(languageID, FPlusLanguageConfiguration)

    const client = new WorkerManager<T, I>('FPlusWorker', languageID)

    const worker: LanguageWorkerAccessor<I> = (...uris: Uri[]): Promise<T> =>
      client.getLanguageServiceWorker(...uris)

    languages.registerCompletionItemProvider(
      languageID,
      new FPlusSuggestionProvider(worker, asWorkerInput),
    )
    languages.registerHoverProvider(
      languageID,
      new FPlusHoverProvider(worker, asWorkerInput),
    )
    languages.registerSignatureHelpProvider(
      languageID,
      new FPlusSignatureHelpProvider(worker, asWorkerInput),
    )
    //Call the errors provider
    languages.registerDocumentFormattingEditProvider(
      languageID,
      new FPlusFormattingProvider(worker, asWorkerInput),
    )
    new FPlusValidationProvider(languageID, worker, asWorkerInput, (a, m) => {
      const model = m as ITextModel
      model.setCompiles(a)
    })
  })
}
